// TODO rename this.
// maybe sth. like: chart-visualization

export default {
    state: {
        chartTypes: [
            {description: "Line Chart", type: 'line', stacking: null, img: 'line.svg'},
            {description: "Scatter Chart", type: 'scatter', stacking: null, img: 'scatter.svg'},

            {description: "Area Chart", type: 'area', stacking: null, img: 'area.svg'},
            {description: "Stacked Area Chart", type: 'area', stacking: 'normal', img: 'stacked_area.svg'},
            {
                description: "Stacked Area Percent Chart",
                type: 'area',
                stacking: 'percent',
                img: 'stacked_area_percent.svg'
            },
            {description: "Column Chart", type: 'column', stacking: null, img: 'column.svg'},
            {description: "Stacked Column Chart", type: 'column', stacking: 'normal', img: 'stacked_column.svg'},
            {
                description: "Stacked Column Percent Chart",
                type: 'column',
                stacking: 'percent',
                img: 'stacked_column_percent.svg'
            },
            {description: "Bar Chart", type: 'bar', stacking: null, img: 'bar.svg'},
            {description: "Stacked Bar Chart", type: 'bar', stacking: 'normal', img: 'stacked_bar.svg'},
            {
                description: "Stacked Bar Percent Chart",
                type: 'bar',
                stacking: 'percent',
                img: 'stacked_bar_percent.svg'
            },
        ],
    }
}
